import { render, staticRenderFns } from "./TrustPublication.vue?vue&type=template&id=480c3cb4&scoped=true"
import script from "./TrustPublication.vue?vue&type=script&lang=ts"
export * from "./TrustPublication.vue?vue&type=script&lang=ts"
import style0 from "./TrustPublication.vue?vue&type=style&index=0&id=480c3cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c3cb4",
  null
  
)

export default component.exports